import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { sendAcquirePolygonAsset } from '@api/assets';

import { IAcquirePolygonAssetDTO } from '@interfaces/map/dto/polygonDTO';

import { ESnackbarTypes } from '@enums/common';

import {
	ACQUIRE_ASSET,
	ASSET_CART_REQUEST_AVAILABLE,
	ASSET_CART_REQUEST_COUNT,
	ASSET_CART_REQUEST_DROPDOWN,
	ASSET_CART_REQUEST_UNAVAILABLE,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateSendAcquirePolygonAsset = (onSuccessCallbacks?: Array<() => void>) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleSendAcquirePolygonAsset,
		isLoading: isSendingAcquirePolygonAsset,
	} = useMutation<IAcquirePolygonAssetDTO>({
		mutationKey: [ACQUIRE_ASSET],
		mutationFn: sendAcquirePolygonAsset,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.sendAcquireAsset,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks?.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}

			return [
				queryClient.invalidateQueries([ASSET_CART_REQUEST_COUNT]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_DROPDOWN]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_AVAILABLE]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_UNAVAILABLE]),
			];
		},
	});

	return {
		handleSendAcquirePolygonAsset,
		isSendingAcquirePolygonAsset,
	};
};
